module.exports = __webpack_public_path__ + "static/wag-tag-logo-right-966e4c0dfdd33370b70f58dd48628df3.png";